import React from 'react';
import { Box, Paper, Avatar, Typography, Grid, IconButton, Chip, Card } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

const Tweet = ({ avatarUrl, name, handle, date, content, tags }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    // <Paper elevation={1} sx={{ p: 1, maxWidth: '80%', backgroundColor: "white", position: 'relative' }}>
      <Card variant="outlined" sx={{ p: 1, maxWidth: '300px', backgroundColor: "white", position: 'relative' }}>
      {/* Copy icon positioned at the top right */}
      <IconButton 
        onClick={handleCopy}
        disableRipple
        disableFocusRipple
        size="small"
        sx={{ 
          position: 'absolute', 
          top: 8, 
          right: 8, 
          p: 0, 
          '&:focus': { outline: 'none' } 
        }}
      >
        {copied ? <CheckIcon color="success" fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
      </IconButton>
      
      {/* Header row */}
      <Grid container spacing={2}>
        {/* Left column: Avatar */}
        <Grid item>
          <Avatar src={avatarUrl} alt={name} />
        </Grid>
        {/* Right column: Name, Verified Icon, Handle and Date */}
        <Grid item xs>
          <Box>
            <Box display="flex" alignItems="center">
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mr: 0.5 }}>
                {name}
              </Typography>
              <VerifiedUserIcon sx={{ fontSize: '1rem', color: '#1DA1F2', mr: 0.5 }} />
            </Box>
          </Box>
          <Typography variant="body2" color="text.secondary">
              @{handle} · {date}
          </Typography>
        </Grid>
      </Grid>
      {/* Tweet content */}
      <Typography variant="body2" sx={{ mt: 1 }}>
        {content}
      </Typography>
      {/* Render tweet tags */}
      {tags && tags.length > 0 && (
        <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {tags.map((tag, index) => (
            <Chip key={index} label={`${tag}`} color="success" variant="outlined" />
          ))}
        </Box>
      )}
    </Card>
  );
};

export default Tweet;
